import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/esm/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
var _dec, _class, _QuizEntryShow;
function _callSuper(_this, derived, args) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
      return !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    } catch (e) {
      return false;
    }
  }
  derived = _getPrototypeOf(derived);
  return _possibleConstructorReturn(_this, isNativeReflectConstruct() ? Reflect.construct(derived, args || [], _getPrototypeOf(_this).constructor) : derived.apply(_this, args));
}
/** @jsx jsx */
import { Component } from 'react';
import PropTypes from 'prop-types';
import ImmutablePropTypes from 'react-immutable-proptypes';
import partial from 'lodash/partial';
import { DragSource } from 'react-dnd';
import { IconAiColoredSolid, IconBankLine } from '@instructure/ui-icons';
import { ScreenReaderContent } from '@instructure/ui-a11y-content';
import { jsx } from '@instructure/emotion';
import { FillBlankInteractionType } from '@instructure/quiz-interactions';
import { TOP, withStyleOverrides } from '@instructure/quiz-common';
import t from '@instructure/quiz-i18n/format-message';
import { convertFITBtoRich } from '../../../../../common/util/fitbCopyHelper';
import Item from '../../../../../common/records/Item';
import Overlay from '../../../../../common/components/shared/overlay';
import ActionButtons from '../../ActionButtons';
import { ItemTypes, dragSource, collectDrag } from '../../../../../common/components/shared/drag_and_drop/dragAndDropUtils';
import PositionBox from '../../../../../common/components/resources/positionBox/PositionBox';
import DragAndDropZone from '../../../../../common/components/shared/drag_and_drop/DragAndDropZone';
import generateStyle from './styles';
import generateComponentTheme from './theme';
import { Tooltip } from '@instructure/ui-tooltip';
import { View } from '@instructure/ui-view';
var QuizEntryShow = (_dec = withStyleOverrides(generateStyle, generateComponentTheme), _dec(_class = (_QuizEntryShow = /*#__PURE__*/function (_Component) {
  function QuizEntryShow() {
    var _this2;
    _classCallCheck(this, QuizEntryShow);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _callSuper(this, QuizEntryShow, [].concat(args));
    _defineProperty(_this2, "state", {
      editAfterCall: null,
      copyAfterCall: null
    });
    _defineProperty(_this2, "editingOn", function () {
      if (_this2.inProgressCall()) {
        _this2.setState({
          editAfterCall: _this2.inProgressCall()
        });
        return;
      }
      if (!_this2.props.quizEntryWithErrorsShowing) {
        var msg = t('Question switched to editing mode.');
        _this2.props.screenreaderNotification(msg);
        _this2.props.switchOnEditing();
      }
    });
    _defineProperty(_this2, "removeItem", function (e) {
      _this2.props.withConfirm(partial(_this2.props.removeQuizEntry, _this2.props.quizId, _this2.props.quizEntry), _this2.removalDialogData());
    });
    _defineProperty(_this2, "copyItem", function () {
      if (_this2.inProgressCall()) {
        _this2.setState({
          copyAfterCall: _this2.inProgressCall()
        });
        return;
      }
      if (_this2.props.quizEntryWithErrorsShowing) {
        _this2.props.screenreaderNotification(t('Question {itemPosition, number} cannot be saved due to invalid input data', {
          itemPosition: Math.ceil(_this2.props.quizEntryWithErrorsShowing.position)
        }));
        return;
      }
      var _this2$props = _this2.props,
        quizId = _this2$props.quizId,
        quizEntry = _this2$props.quizEntry,
        entry = _this2$props.entry,
        richFITBEnabled = _this2$props.richFITBEnabled,
        richFITBInteractionID = _this2$props.richFITBInteractionID;
      var interactionTypeData = {
        answerFeedback: entry.answerFeedback,
        calculatorType: entry.calculatorType,
        feedback: entry.feedback,
        id: entry.interactionType,
        interactionData: entry.interactionData,
        itemBody: entry.itemBody,
        outcomeAlignmentSetGuid: entry.outcomeAlignmentSetGuid,
        properties: entry.properties,
        scoringAlgorithm: entry.scoringAlgorithm,
        scoringData: entry.scoringData,
        title: entry.title
      };
      if (richFITBEnabled && entry.getInteractionType() instanceof FillBlankInteractionType) {
        interactionTypeData = convertFITBtoRich(interactionTypeData, richFITBInteractionID);
      }
      _this2.props.createItem(quizId, Math.round(quizEntry.position + 1), interactionTypeData, quizEntry.stimulusQuizEntryId, entry.stimulusId, quizEntry.pointsPossible);
    });
    return _this2;
  }
  _inherits(QuizEntryShow, _Component);
  return _createClass(QuizEntryShow, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      // Must wait for create/update call to complete successfully, because quiz_api
      // can return validation errors, preventing the editing/copying of this QuizEntry.
      if (this.state.editAfterCall && this.callStatus(this.state.editAfterCall) !== 'calling') {
        if (this.callStatus(this.state.editAfterCall) === 'success') {
          this.editingOn();
        }
        this.setState({
          editAfterCall: null
        });
      }
      if (this.state.copyAfterCall && this.callStatus(this.state.copyAfterCall) === 'error') {
        this.setState({
          copyAfterCall: null
        });
      }
      // In addition to the create/update call, copy must wait for the previous temporary
      // quizEntry to be cleared out of the modifications store before putting the copy info there
      var copySuccess = this.callStatus(this.state.copyAfterCall) === 'success';
      if (this.state.copyAfterCall && copySuccess && this.props.modificationsClear) {
        this.copyItem();
        this.setState({
          copyAfterCall: null
        });
      }
    }
  }, {
    key: "callStatus",
    value: function callStatus(call) {
      return {
        create: this.props.createItemCallStatus,
        update: this.props.updateItemCallStatus
      }[call];
    }
  }, {
    key: "inProgressCall",
    value: function inProgressCall() {
      if (this.props.createItemCallStatus === 'calling') {
        return 'create';
      }
      if (this.props.updateItemCallStatus === 'calling') {
        return 'update';
      }
      return false;
    }
  }, {
    key: "getPointsText",
    value: function getPointsText(points) {
      return t("{\n      points, plural,\n        one {# point}\n      other {# points}\n    }", {
        points: points
      });
    }
  }, {
    key: "removalDialogData",
    value: function removalDialogData() {
      return {
        title: t('Remove Question?'),
        text: t('Are you sure you want to remove this question?'),
        continueText: t('Remove Question'),
        cancelText: t('Keep Question')
      };
    }
  }, {
    key: "shouldDisableDragHandle",
    value: function shouldDisableDragHandle() {
      return this.props.quizEntries.size === 1;
    }
  }, {
    key: "renderPointsPossible",
    value: function renderPointsPossible() {
      if (this.props.entry instanceof Item) {
        var pointsPossible = this.props.quizEntry.pointsPossible;
        return jsx("div", {
          className: "points",
          css: this.props.styles.points,
          "data-automation": "sdk-points-possible-div"
        }, this.getPointsText(pointsPossible || 0));
      }
    }
  }, {
    key: "renderInteractionType",
    value: function renderInteractionType() {
      if (this.props.entry instanceof Item) {
        var interactionTypeName = this.props.entry.getInteractionType().name || this.props.interactionTypeName;
        return jsx("div", {
          css: this.props.styles.interactionTypeName,
          "data-automation": "sdk-interaction-type-name-div"
        }, interactionTypeName);
      }
    }
  }, {
    key: "renderBankedContent",
    value: function renderBankedContent() {
      if (this.props.quizEntry.isBank || this.props.quizEntry.isBankEntry) {
        return jsx(IconBankLine, null);
      }
    }
  }, {
    key: "renderAiGeneratedContent",
    value: function renderAiGeneratedContent() {
      if (!this.props.quizEntry.isAiGenerated) {
        return null;
      }
      return jsx(View, {
        stacking: "topmost"
      }, jsx(Tooltip, {
        renderTip: t('This question was generated using AI'),
        placement: "top center",
        on: ['hover', 'focus']
      }, jsx(IconAiColoredSolid, {
        color: "primary",
        "aria-label": t('This question was generated using AI')
      })));
    }
  }, {
    key: "renderLeftHeader",
    value: function renderLeftHeader() {
      return jsx("div", {
        css: this.props.styles.leftHeader
      }, this.renderBankedContent(), this.renderAiGeneratedContent(), this.renderInteractionType(), this.renderPointsPossible(), jsx("div", {
        css: this.props.styles.title,
        "data-automation": "sdk-quiz-entry-title-div"
      }, this.props.entry.title));
    }
  }, {
    key: "setInert",
    value: function setInert(node) {
      node && node.setAttribute('inert', '');
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        connectDragPreview = _this$props.connectDragPreview,
        displayPosition = _this$props.displayPosition,
        draggingOver = _this$props.draggingOver,
        draggingAboveHalf = _this$props.draggingAboveHalf,
        quizEntry = _this$props.quizEntry,
        stimulusOrientation = _this$props.stimulusOrientation,
        isContentLockedByBlueprint = _this$props.isContentLockedByBlueprint,
        lockBlueprintContentEnabled = _this$props.lockBlueprintContentEnabled;
      var positionToDisplay = this.props.quizEntry.positionToDisplay(displayPosition);
      var positionText = t('Preview of question at position {position}', {
        position: positionToDisplay
      });
      var srMsg = t('The following question is a preview for the teacher. To edit this question, navigate back to the "Edit Question" button and click.');
      var propsForDnDZone = {
        draggingOver: draggingOver,
        draggingAboveHalf: draggingAboveHalf
      };
      var shouldLockQuizEntry = lockBlueprintContentEnabled && isContentLockedByBlueprint;

      // Overlay gets tabIndex === "-1" so that the drag handle is tabbable before
      // the Overlay get focus and opens the quizEntry in edit mode
      return jsx(Overlay, {
        onClick: this.editingOn,
        wrapperStyles: this.props.styles.quizEntryWrapper,
        tabIndex: "-1",
        hideOverlay: shouldLockQuizEntry
      }, jsx(DragAndDropZone, Object.assign({}, propsForDnDZone, {
        location: "above"
      })), jsx("div", {
        ref: connectDragPreview,
        css: this.props.styles.quizEntryShow,
        "data-automation": "sdk-quiz-entry-show",
        "data-automation-item-id": this.props.quizEntry.id
      }, jsx("div", {
        css: this.props.styles.header
      }, quizEntry.isInStimulus && stimulusOrientation === TOP && jsx("div", {
        css: this.props.styles.connectingLines
      }), jsx(PositionBox, {
        position: positionToDisplay,
        headingText: positionText,
        headingLevel: quizEntry.isInStimulus ? 'h3' : 'h2'
      }), this.renderLeftHeader(), jsx(ActionButtons, {
        connectDragSource: this.props.connectDragSource,
        displayPosition: this.props.displayPosition,
        onDelete: this.removeItem,
        onCopy: this.props.quizEntry.isBank ? null : this.copyItem,
        quizEntries: this.props.quizEntries,
        quizEntry: this.props.quizEntry,
        scrollKey: this.props.scrollKey,
        shouldDisableDragHandle: this.shouldDisableDragHandle(),
        switchOnEditing: this.editingOn,
        shouldFocusOnMount: this.props.editQuizEntryToggle,
        shouldDisableCopy: shouldLockQuizEntry,
        shouldRenderEdit: !shouldLockQuizEntry,
        shouldRenderDelete: !shouldLockQuizEntry
      }), jsx(ScreenReaderContent, null, srMsg)), jsx("div", {
        css: this.props.styles.itemHolder,
        ref: this.setInert,
        "data-automation": "sdk-quiz-entry-show-item-holder"
      }, this.props.children)), jsx(DragAndDropZone, Object.assign({}, propsForDnDZone, {
        location: "below"
      })));
    }
  }]);
}(Component), _defineProperty(_QuizEntryShow, "displayName", 'QuizEntryShow'), _defineProperty(_QuizEntryShow, "componentId", "Quizzes".concat(_QuizEntryShow.displayName)), _defineProperty(_QuizEntryShow, "propTypes", {
  children: PropTypes.oneOfType([PropTypes.arrayOf(PropTypes.node), PropTypes.node]),
  connectDragPreview: PropTypes.func.isRequired,
  connectDragSource: PropTypes.func.isRequired,
  createItem: PropTypes.func.isRequired,
  createItemCallStatus: PropTypes.string.isRequired,
  displayPosition: PropTypes.number.isRequired,
  draggingOver: PropTypes.bool.isRequired,
  draggingAboveHalf: PropTypes.bool.isRequired,
  editQuizEntryToggle: PropTypes.bool.isRequired,
  entry: ImmutablePropTypes.record.isRequired,
  haveValidationErrorsFromApi: PropTypes.bool,
  // only used in index.js
  interactionTypeName: PropTypes.string,
  modificationsClear: PropTypes.bool.isRequired,
  lockBlueprintContentEnabled: PropTypes.bool.isRequired,
  quizEntryWithErrorsShowing: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  quizEntries: ImmutablePropTypes.listOf(ImmutablePropTypes.record).isRequired,
  quizEntry: ImmutablePropTypes.record.isRequired,
  quizId: PropTypes.string.isRequired,
  isContentLockedByBlueprint: PropTypes.bool.isRequired,
  removeQuizEntry: PropTypes.func.isRequired,
  // from connected component
  richFITBEnabled: PropTypes.bool,
  richFITBInteractionID: PropTypes.string,
  screenreaderNotification: PropTypes.func.isRequired,
  // from connected component
  scrollKey: PropTypes.string,
  stimulusOrientation: PropTypes.string,
  switchOnEditing: PropTypes.func.isRequired,
  // from QuizEntry
  updateItemCallStatus: PropTypes.string.isRequired,
  withConfirm: PropTypes.func.isRequired,
  styles: PropTypes.object
}), _defineProperty(_QuizEntryShow, "defaultProps", {
  children: null,
  draggingOver: false,
  draggingAboveHalf: false,
  lockBlueprintContentEnabled: false,
  quizEntryWithErrorsShowing: null,
  scrollKey: void 0,
  editQuizEntryToggle: false,
  haveValidationErrorsFromApi: false,
  interactionTypeName: null,
  isContentLockedByBlueprint: false,
  richFITBEnabled: false,
  richFITBInteractionID: '',
  stimulusOrientation: null
}), _QuizEntryShow)) || _class);
export var QuizEntryShowRaw = QuizEntryShow;
export var QuizEntryShowPresenter = DragSource(ItemTypes.QUIZ_ENTRY, dragSource, collectDrag)(QuizEntryShow);
export default QuizEntryShowPresenter;